<nav class="breadcrumb bg-primary">
  <div class="container">
    <div class="row align-items-center">
      <div class="col pb-4">
      </div>
      <div class="col-auto">
        <span class="breadcrumb-item">
          <a class="text-white pr-2" href="index.html">Domov</a>
        </span>
        <span class="text-white text-muted">
          >
        </span>
        <span class="text-white text-muted pl-2">
          Blog
        </span>
      </div>
    </div>
  </div>
</nav>

<section class="section pb-0 bg-white" style="padding-top: 60px">
  <div class="container">
    <div class="row">
      <h1 style="font-size: 48px">Blog Gryf</h1>
    </div>
    <div *ngIf="blogGetOverviewResponse">
      <div *ngIf="blogGetOverviewResponse.list" class="card-columns">
        <div *ngFor="let blog of blogGetOverviewResponse.list" class="card blog-card card-transform-effect" (click)="showBlogDetailbyUrl(blog.nameUrl)">
          <div *ngIf="blog.safeBase64Content" class="blog-main-photo">
            <img class="img-fluid" [src]="blog.safeBase64Content" alt="{{blog.title1}}" loading="lazy">
          </div>
          <div class="card-body blog-title">
            <h3><a [routerLink]="['/blog', blog.nameUrl]">{{blog.title1}}</a></h3>
            <p class="card-text pt-3">{{(blog.description1.length > 300) ? (blog.description1 | slice:0:300)+'...' : (blog.description1)}}</p>
            <small class="text-muted">
              <cite>{{getFormattedDate(blog.createdTs)}}, vytvoril(a): {{blog.authorName}}</cite>
            </small>
          </div>
        </div>
      </div>
    </div>

   <!-- Pagination-->
    <div class="pagination-div pt-5 pb-5">
      <ul class="pagination-list">
        <li *ngIf="startEnd && actualPageIndex != 0" class="pagination-item">
          <a [routerLink]="['/blog/page', (actualPageIndex - 1)]"><<</a>
        </li>
        <li class="pagination-item">
          <a id="0" [class.active-page]="actualPageIndex === 0" [routerLink]="['/blog/page', 0]">1</a>
        </li>
        <li class="pagination-item" *ngFor="let button of buttons; let i = index">
          <a id="{{i+1}}" [class.active-page]="actualPageIndex === i+1" [routerLink]="['/blog/page', (i+1)]">{{button+2}}</a>
        </li>
        <li *ngIf="startEnd && actualPageIndex != buttons.length" class="pagination-item">
          <a [routerLink]="['/blog/page', (actualPageIndex + 1)]">>></a>
        </li>
      </ul>
    </div>
  </div>
</section>
